/**
 * @module builder
 */
import type { OptionsDocument, PipelineStage } from 'paintscout'
import { getPipelines } from '../../options/'

// export const DEAL_SALES_STAGE_OPTIONS = [
//   { value: 'lead', label: 'New Lead' },
//   { value: 'estimate-scheduled', label: 'Estimate Scheduled' },
//   { value: 'estimate-sent', label: 'Estimate Sent' },
//   { value: 'estimate-accepted', label: 'Estimate Accepted' },
//   { value: 'estimate-declined', label: 'Estimate Declined' }
// ]
// export const DEAL_PRODUCTION_STAGE_OPTIONS = [
//   { value: 'estimate-accepted', label: 'Estimate Accepted' },
//   { value: 'production-scheduled', label: 'Production Scheduled' },
//   { value: 'production-in-progress', label: 'Production In Progress' },
//   { value: 'production-complete', label: 'Production Complete' }
// ]

export function getDealStageOptions(args: { options: OptionsDocument; pipeline: string }): PipelineStage[] {
  const { pipeline: pipelineKey, options } = args ?? {}
  const pipelines = getPipelines({ options })

  if (pipelineKey === 'all') {
    return pipelines.reduce((acc, pipeline) => {
      const stages = pipeline.stages.map((stage) => ({
        ...stage,
        pipeline: pipeline.key
      }))
      return [...acc, ...stages]
    }, [] as PipelineStage[])
  }

  const pipeline = pipelines.find((pipeline) => pipeline.key === pipelineKey)
  if (!pipeline) {
    console.log(`Pipeline with key ${pipelineKey} not found`)
    return []
    // throw new Error(`Pipeline with key ${pipelineKey} not found`)
  }
  return pipeline.stages
}
